import React from 'react';
import Alert from '@mui/material/Alert';

const AlertPage = (props) => {
  const capitalize = (word) => {
    const lower = word.toLowerCase();
    return lower.charAt(0).toUpperCase() + lower.slice(1);
  };

  return (
    props.alert && (
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 9999,
          width: "auto",
          maxWidth: "80vw"
        }}
      >
        <Alert
          variant="filled"
          severity={props.alert.type}
          style={{
            fontSize: "18px",
            fontWeight: "bold",
            padding: "36px",
            minWidth: "300px",
            textAlign: "center",
            borderRadius: "50px"
          }}
        >
          <b>{capitalize(props.alert.type)}</b>: {props.alert.msg}
        </Alert>
      </div>
    )
  );
};

export default AlertPage;
